<template>
  <div class="token-page">
    <div class="filter-box">
      <a-form layout="inline">
        <a-form-item>
          <a-button v-permission="PERMISSIONS.TOKEN_MANAGE" @click="createToken">创建Token</a-button>
          <a-tooltip>
            <template slot="title"> 点击创建新的 API Token </template>
          </a-tooltip>
        </a-form-item>
        <a-form-item v-if="isAdmin">
          <a-input v-model="queryParams.username" placeholder="创建人" allow-clear style="width: 160px" />
        </a-form-item>
        <a-form-item>
          <a-select v-model="queryParams.is_active" placeholder="有效状态" allow-clear style="width: 120px">
            <a-select-option :value="1">有效</a-select-option>
            <a-select-option :value="0">无效</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="searchToken">搜索</a-button>
          <a-button @click="resetQuery">重置</a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      bordered
      size="small"
      :data-source="dataSource"
      :columns="columns"
      :rowKey="record => record.id"
      :pagination="pagination"
      :loading="loading"
      :scroll="{ y: tableScrollY }"
      @change="handleTableChange"
    >
      <template slot="token" slot-scope="text">
        <a-tooltip :title="text">
          <span class="token-text">{{ text }}</span>
        </a-tooltip>
      </template>
      <template slot="operation" slot-scope="record">
        <div class="button-box">
          <a-button @click="copyToken(record)">复制</a-button>
          <a-popconfirm title="确认删除该token?" ok-text="确认" cancel-text="取消" @confirm="deleteToken(record)">
            <a-button v-permission="PERMISSIONS.TOKEN_MANAGE">删除</a-button>
          </a-popconfirm>
        </div>
      </template>
    </a-table>
  </div>
</template>

<script>
import { getTokenList, deleteToken, createToken } from '@/api/notice'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      columns: [
        {
          title: 'ID',
          key: 'id',
          dataIndex: 'id',
          width: '10%'
        },
        {
          title: 'Token',
          dataIndex: 'token',
          width: '35%',
          scopedSlots: { customRender: 'token' }
        },
        {
          title: '创建人',
          dataIndex: 'username',
          width: '15%'
        },
        {
          title: '有效状态',
          dataIndex: 'is_active',
          width: '10%',
          customRender: text => {
            const color = text === 1 ? 'green' : 'red'
            return <a-tag color={color}>{text === 1 ? '有效' : '无效'}</a-tag>
          }
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: '15%'
        },
        {
          title: '操作',
          key: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      dataSource: [],
      currentPage: 1,
      pageSize: 10,
      total: 1,
      loading: false,
      tableScrollY: 0,
      queryParams: {
        username: '',
        is_active: undefined
      },
      pagination: {
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      }
    }
  },
  computed: {
    ...mapGetters(['ntcRole']),
    isAdmin() {
      return this.ntcRole === 'admin'
    }
  },
  created() {},
  mounted() {
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
    this.getTokenList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
  methods: {
    calcTableHeight() {
      const pageHeight = window.innerHeight
      const headerHeight = 64
      const contentMargin = 48
      const contentPadding = 48
      const paginationHeight = 52
      const filterBox = document.querySelector('.token-page .filter-box')
      const filterHeight = filterBox ? filterBox.clientHeight : 52
      const extraGap = 0
      this.tableScrollY = pageHeight - headerHeight - contentMargin - contentPadding - filterHeight - paginationHeight - extraGap
    },
    searchToken() {
      const params = {
        page_num: 1,
        page_size: this.pageSize,
        ...this.queryParams
      }
      this.getTokenList(params)
    },
    resetQuery() {
      this.queryParams = {
        username: '',
        is_active: undefined
      }
      this.getTokenList()
    },
    handleTableChange(pagination, filters) {
      const params = {
        page_num: pagination.current,
        page_size: pagination.pageSize,
        ...this.queryParams,
        ...filters
      }
      this.getTokenList(params)
    },
    getTokenList(params = { page_size: 10 }) {
      this.loading = true
      getTokenList(params)
        .then(res => {
          this.dataSource = res.data.list
          this.total = res.data.total
          this.pagination.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.dataSource = []
          this.total = 0
          this.pagination.total = 0
          this.loading = false
        })
    },
    createToken() {
      createToken()
        .then(() => {
          this.getTokenList()
        })
        .catch(() => {
          this.getTokenList()
        })
    },
    copyToken(data) {
      navigator.clipboard.writeText(data.token)
      this.$notification['success']({
        message: '复制成功',
        description: "Token已被复制，使用时需添加到HTTP_Header Authorization中。例如：Authorization: Bearer {user's access token}",
        onClick: () => {
          console.log('Notification Clicked!')
        },
        duration: 10
      })
    },
    deleteToken(data) {
      deleteToken(data.id)
        .then(() => {
          this.getTokenList()
          this.$message.success(`删除成功`, 2)
        })
        .catch(() => {
          this.getTokenList()
          this.$message.error(`删除失败`, 2)
        })
    }
  }
}
</script>

<style scoped>
.token-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.filter-box {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.token-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.button-box {
  display: flex;
  justify-content: space-evenly;
}
</style>
